<template>
  <DialogContainer v-model="dialogObj">
    <template v-slot:dialogSlot>
      <div class="business-body custom-form">
        <el-row>
          <el-col :span="12" class="label-val">
            <span class="label">用户信息：</span>
            <span class="value">{{ form.feedbackUsername }}</span>
          </el-col>
          <el-col :span="12" class="label-val">
            <span class="label">提交时间：</span>
            <span class="value">{{ form.feedbackTime }}</span>
          </el-col>
          <el-col :span="12" class="label-val">
            <span class="label">问题类型：</span>
            <span class="value">{{ form.feedbackType }}</span>
          </el-col>
          <el-col :span="24" class="label-val">
            <span class="label">反馈描述：</span>
            <span class="value">{{ form.feedbackContent }}</span>
          </el-col>
        </el-row>
        <div class="title-box" v-if="!form.reply && !isDetail">
          <el-image :src="cheImage" class="title-label"></el-image>客服回复
        </div>
        <template v-if="!isDetail">
          <el-row :gutter="20">
            <el-form
              ref="form"
              :model="form"
              :rules="rules"
              label-position="top"
            >
              <el-col :span="24">
                <el-form-item prop="replyContent">
                  <el-input
                    type="textarea"
                    clearable
                    rows="4"
                    placeholder="请输入回复内容，注意礼貌，文明用词"
                    v-model="form.replyContent"
                    maxlength="50"
                    show-word-limit
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-form>
          </el-row>
        </template>
        <template v-else>
          <template v-if="form.reply">
            <el-row class="common-info-box">
              <el-col :span="12">
                <span class="label">操作人：</span>
                <span class="value">{{ form.replyUsername }}</span>
              </el-col>
              <el-col :span="12">
                <span class="label">操作时间：</span>
                <span class="value">{{ form.replyTime }}</span>
              </el-col>
              <el-col :span="24">
                <span class="label">回复内容：</span>
                <span class="value">{{ form.replyContent }}</span>
              </el-col>
            </el-row>
          </template>
        </template>
      </div>
    </template>
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import { validatePhone } from "@/utils/validate";
import { addInfo, editInfo, replyFeedback, setReal } from "./api";
import { getRoleSelect } from "@/views/commonApi";
import { userSms } from "@/views/login/api";
export default {
  name: "AddOrEdit",
  components: {
    DialogContainer,
  },
  data() {
    return {
      cheImage: require("@/assets/imgs/title.png"),
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "30%",
        show: false,
        title: "修改客户归属",
        closeOnClickModal: false,
        confirmFn: this.submitForm,
        beforeClose: (v) => {
          this.form = this.$options.data().form;
          if (this.$refs.form) this.$refs.form.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      form: {
        feedbackId: "",
        replyContent: "",
      },
      rules: {
        replyContent: [{ required: true, message: "回复内容不能为空" }],
      },
      isDetail: false,
    };
  },
  mounted() {},
  methods: {
    init(title, isDetail, row) {
      this.dialogObj.title = title;
      this.isDetail = isDetail;
      if (this.isDetail) {
        this.dialogObj.confirmFn = "";
      } else {
        this.dialogObj.confirmFn = this.submitForm;
      }
      if (!!row) {
        this.form = Object.assign({}, row);
      }
      this.dialogObj.show = true;
    },

    // 提交数据
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.dialogObj.btnLoading = true;
          const par = {
            feedbackId: this.form.feedbackId,
            replyContent: this.form.replyContent,
          };
          replyFeedback(par)
            .then((res) => {
              this.dialogObj.btnLoading = false;
              if (res.code === 200) {
                this.$message.success("回复成功");
                this.$parent.handleAddOrEditSuccess("edit", "terminalType");
                this.dialogObj.beforeClose();
              }
            })
            .catch((e) => {
              this.dialogObj.btnLoading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  box-sizing: border-box;
  .label-val {
    margin-bottom: 0.16rem;
  }
  .title-box {
    padding: 0rem 0 0.1rem;
    color: #000000;
    .title-label {
      width: 0.08rem;
      height: 0.08rem;
      margin-right: 0.06rem;
    }
  }
  .common-info-box {
    padding: 0.1rem;
    box-sizing: border-box;
    background: #f7f8fb;
    line-height: 0.24rem;
    border-radius: 0.08rem;
  }
}
</style>
